// FolderManagement.js
import React, { useEffect, useMemo, useState } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Divider,
  FormGroup,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Modal,
  Typography,
} from "@mui/material";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import { ThemeColor } from "../../component/theme/color";
import CustomButton from "../../component/button/button";
import "../foldermanagement/foldermanagement.css";
import FolderMenu from "../../Icon/FolderMenu";
import FolderShare from "../../Icon/FolderShare";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  unstable_HistoryRouter,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  FolderStackAction,
  GetFileAction,
  GetFolderAction,
  GetFolderAndFilesByParentlistAction,
} from "../../Redux/action/FileManagerAction";
import {
  CreateFolderService,
  UpdateFileService,
  UpdateFolderService,
} from "../../Redux/service/FileManagerService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Crossicon from "../../Icon/Crossicon";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { AddCircleOutlined, Check, Close } from "@mui/icons-material";
import { CreateFileModal } from "./CreateFileModal.component";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  FileManagerNoResult,
  FileManagerSearch,
  useFileManagerSearch,
} from "./FileManagerSearch.component";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "94%", sm: 460, md: 500 },
  maxWidth: "100%",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: "0 24px 60px rgba(16, 24, 40, 0.22)",
  p: { xs: 2.5, sm: 3 },
  outline: "none",
};

// A constant type for drag-and-drop items
const ItemTypes = {
  FILE: "file",
  FOLDER: "folder",
};

const getFileIcon = (fileName) => {
  if (!fileName) return "";

  const extension = fileName.split(".").pop()?.toLowerCase();

  switch (extension) {
    case "pdf":
      return "/assest/folderpng/pdf.png"; // Path to your PDF icon
    case "xlsx":
    case "xls":
      return "/assest/folderpng/excel.png";
    case "jpg":
    case "jpeg":
    case "svg":
    case "png":
      return "/assest/folderpng/jpg_jpeg.png";
    case "docx":
      return "/assest/folderpng/word.png";
    // Path to your Excel icon
    default:
      return "/assest/folderpng/folder.png"; // Default file icon
  }
};

// Folder component
const Folder = ({
  folder,
  onDrop,
  onClick,
  moveFolder,
  handleFolderActionFromChild,
}) => {
  const navigate = useNavigate();
  const disptach = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [folderstack, setFolderstack] = useState([]);
  const [renameOn, setRenameOn] = useState("none");
  // const [_, setRender] = useState(false);
  const [{ isOver }, drop] = useDrop({
    accept: [ItemTypes.FILE, ItemTypes.FOLDER],
    drop: (item) => {
      //(item, "inside the drop of folder");
      if (item.type === ItemTypes.FOLDER) {
        moveFolder(item.id, folder.id); // Handle moving folders
      } else {
        onDrop(item, folder.id); // Handle file drop
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  // const [folderstack, setFolderstack] = useState([]);
  // const FolderStackState = useSelector(
  //   (state) => state.fileManager?.folderstack
  // );
  // //("stack of the folder", FolderStackState);
  // useEffect(() => {
  //   setFolderstack(FolderStackState);
  // }, [FolderStackState]);

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.FOLDER,
    item: { id: folder.id, type: ItemTypes.FOLDER },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  const dragDropRef = (node) => {
    drag(node); // Assign drag ref
    drop(node); // Assign drop ref
  };

  const handleRename = async () => {
    setRenameOn("flex");
  };

  const updateFileSchema = Yup.object().shape({
    name: Yup.string().required("Name of file is required."),
  });

  return (
    <div
      //   ref={drag}
      ref={dragDropRef}
      className="fm-row"
      style={{
        opacity: isDragging ? 0.5 : 1,
        backgroundColor: isOver ? "#e8f7ec" : "",
      }}
      onClick={() => onClick(folder)}
    >
      <Box className="file">
        <div className="w-100 d-flex">
          <div
            className="filename-icon"
            style={{ width: "25px", height: "25px" }}
          >
            <img
              src="/assest/folderpng/folder.png"
              alt="file icon"
              className="w-100 h-100"
            ></img>
          </div>
          <div className="file-name px-2 w-100">
            <Typography
              onClick={() => {
                //(folder.id, "folder id when folder click");
                // const duplicateId = folderstack.some((id) => id === folder.id);
                // //(duplicateId, "status of stack");
                // if (!duplicateId) disptach(FolderStackAction(folder.id));
                // disptach(GetFolderAndFilesByParentlistAction(folder.id))

                navigate(`/CAE/FileManager/Folder/${folder.id}`);
                // setRender((prev) => !prev);
              }}

              // onClick={() => {
              //   const duplicateId = folderstack.some((id) => id === folder.id);
              //   //(duplicateId, "status of stack");
              //   // if (!duplicateId) disptach(FolderStackAction(folder.id));
              //   navigate(`Folder/${folder.id}`);
              // }}
              sx={{ display: renameOn === "none" ? "flex" : "none" }}
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W500}
              fontSize={fontSize.h3.medium}
            >
              {folder.name}
            </Typography>
            <Box
              sx={{ display: renameOn === "none" ? "none" : "flex" }}
              className="w-100"
            >
              <Formik
                initialValues={{
                  name: folder ? folder.name : "",
                }}
                validationSchema={updateFileSchema}
                className="w-100"
                onSubmit={async (values) => {
                  //(values, "agent payload");
                  await UpdateFolderService(values, folder.id)
                    .then((res) => {
                      //(res);
                      if (res.status === 200) {
                        //(res);
                        handleFolderActionFromChild();

                        disptach(showSnackbar(res.data.message, "success"));
                        setRenameOn("none");
                      }
                    })
                    .catch((e) => {
                      disptach(showSnackbar(apiErrorMessage(e), "error"));
                    });
                }}
              >
                {({
                  values,
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  handleSubmit,
                  setFieldValue,
                  resetForm,
                }) => (
                  <Form className="w-100" onSubmit={handleSubmit}>
                    <Grid container spacing={2} className="">
                      <Grid item lg={6} xs={6}>
                        <div className="">
                          <OutlinedInputField
                            value={values.name}
                            name={"name"}
                            onChange={handleChange}
                            placeholder="Update file name"
                            fullWidth={true}
                            onBlur={handleBlur}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.name}
                              </Typography>
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item lg={6} xs={6}>
                        <Box
                          sx={{
                            flexDirection: {
                              lg: "row",
                              md: "row",
                              sm: "column",
                              xs: "column",
                            },
                          }}
                          className=""
                        >
                          <IconButton type="submit">
                            <Check sx={{ fill: ThemeColor.BLUE }} />
                          </IconButton>
                          <IconButton>
                            <Close
                              sx={{ fill: "red" }}
                              onClick={() => {
                                setRenameOn("none");
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      </Box>

      {/* <Box className="file-action">
        <div className="w-100 d-flex justify-content-end justify-content-between">
          <div className="file-action-content d-flex">
            <div className="px-2">
              <IconButton
                sx={{ padding: 0 }}
                // onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                <FolderMenu />
              </IconButton>
              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem onClick={handleRename}>Rename</MenuItem>
              </Menu>
            </div>
            <div className="px-2">
              <FolderShare />
            </div>
          </div>

          <div className="file-action-date d-flex">
            <Typography
              fontFamily={FontFamily.Poppins}
              fontSize={fontSize.h3.small}
              fontWeight={fontWeight.W500}
              color={ThemeColor.GREY}
            >
              {dayjs().format("DD/MM/YYYY")}
            </Typography>
          </div>
        </div>
      </Box> */}
    </div>
  );
};

// File component
const File = ({ file, handleFolderActionFromChild }) => {
  const disptach = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [renameOn, setRenameOn] = useState("none");

  const handleRename = async () => {
    setRenameOn("flex");
  };

  const updateFileSchema = Yup.object().shape({
    name: Yup.string().required("Name of file is required."),
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.FILE,
    item: { id: file.id, name: file.name },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  const fileIcon = useMemo(() => getFileIcon(file?.name), [file?.name]);

  return (
    <div
      ref={drag}
      className="fm-row"
      style={{
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      <Box className="file">
        <div className="w-100 d-flex">
          <div
            className="filename-icon"
            style={{ width: "25px", height: "25px" }}
          >
            {/* <img
              src="/assest/folderpng/excel.png"
              alt="file icon"
              className="w-100 h-100"
            ></img> */}

            <img
              src={fileIcon}
              alt="file icon"
              style={{ width: "20px", height: "20px" }}
              className="file-icon"
            />
          </div>
          <div className="file-name px-2 w-100">
            <Typography
              sx={{ display: renameOn === "none" ? "flex" : "none" }}
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W500}
              fontSize={fontSize.h3.medium}
            >
              {file.name}
            </Typography>
            <Box
              sx={{ display: renameOn === "none" ? "none" : "flex" }}
              className="w-100"
            >
              <Formik
                initialValues={{
                  name: file ? file.name : "",
                }}
                validationSchema={updateFileSchema}
                className="w-100"
                onSubmit={async (values) => {
                  //(values, "agent payload");
                  await UpdateFileService(values, file.id)
                    .then((res) => {
                      //(res);
                      if (res.status === 200) {
                        //(res);
                        handleFolderActionFromChild();

                        disptach(showSnackbar(res.data.message, "success"));
                        setRenameOn("none");
                      }
                    })
                    .catch((e) => {
                      disptach(showSnackbar(apiErrorMessage(e), "error"));
                    });
                }}
              >
                {({
                  values,
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  handleSubmit,
                  setFieldValue,
                  resetForm,
                }) => (
                  <Form className="w-100" onSubmit={handleSubmit}>
                    <Grid container spacing={2} className="">
                      <Grid item lg={6} xs={6}>
                        <div className="">
                          <OutlinedInputField
                            value={values.name}
                            name={"name"}
                            onChange={handleChange}
                            placeholder="Update file name"
                            fullWidth={true}
                            onBlur={handleBlur}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.name}
                              </Typography>
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item lg={6} xs={6}>
                        <Box
                          sx={{
                            flexDirection: {
                              lg: "row",
                              md: "row",
                              sm: "column",
                              xs: "column",
                            },
                          }}
                          className=""
                        >
                          <IconButton type="submit">
                            <Check sx={{ fill: ThemeColor.BLUE }} />
                          </IconButton>
                          <IconButton>
                            <Close
                              sx={{ fill: "red" }}
                              onClick={() => {
                                setRenameOn("none");
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      </Box>

      <Box className="file-action">
        <div className="w-100 d-flex justify-content-end justify-content-between">
          {/* <div className="file-action-content d-flex">
            <div className="px-2">
              <IconButton
                sx={{ padding: 0 }}
                // onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                <FolderMenu />
              </IconButton>
              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem onClick={handleRename}>Rename</MenuItem>
              </Menu>
            </div>
            <div className="px-2">
              <IconButton
                sx={{ padding: 0 }}
                onClick={() => {

                  window.open(file.url, "_blank", "noopener noreferrer");
                }}
              >
                <VisibilityIcon />
              </IconButton>
            </div>
          </div> */}
          <div className="file-action-content d-flex">
            <div className="px-2">
              <IconButton
                sx={{ padding: 0 }}
              // onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                {/* <FolderMenu /> */}
              </IconButton>
              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem onClick={handleRename}>Rename</MenuItem>
              </Menu>
            </div>
            <div className="px-2">
              <IconButton
                sx={{ padding: 0 }}
                onClick={() => {
                  // window.location.href = `${file.url}`;
                  window.open(file.url, "_blank", "noopener noreferrer");
                }}
              >
                <VisibilityIcon />
              </IconButton>
            </div>
          </div>

          <div className="file-action-date d-flex">
            <Typography
              fontFamily={FontFamily.Poppins}
              fontSize={fontSize.h3.small}
              fontWeight={fontWeight.W500}
              color={ThemeColor.GREY}
            >
              {/* Creation date of this file, not today. */}
              {file.createdAt
                ? dayjs(file.createdAt).format("DD/MM/YYYY")
                : "-"}
            </Typography>
          </div>
        </div>
      </Box>
    </div>
  );
};

// Main Folder Management component
const FolderManagement = (props) => {
  const disptach = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [folderstack, setFolderstack] = useState([]);

  const [parentid, setParentid] = useState();

  const [folders, setFolders] = useState([
    // {
    //   id: 1,
    //   name: "Folder 1",
    //   files: [{ id: 1, name: "File A" }],
    //   subfolders: [],
    // },
    // {
    //   id: 2,
    //   name: "Folder 2",
    //   files: [{ id: 2, name: "File B" }],
    //   subfolders: [],
    // },
  ]);

  const [files, setFiles] = useState([
    // { id: 3, name: "File C" },
    // { id: 4, name: "File D" },
  ]);

  const [selectedFolder, setSelectedFolder] = useState(null);

  const [subFolderdata, setSubFolderdata] = useState();

  const [createFolderModal, setCreateFolderModal] = useState(false);
  const [createFileModal, setCreateFileModal] = useState(false);
  const isAdmin = window?.sessionStorage.getItem("user_role_type") === "admin";
  const subFolderState = useSelector((state) => state.fileManager?.subFolder);
  const isFolderLocked =
    !isAdmin &&
    (subFolderState?.response?.status === 403 ||
      subFolderState?.response?.data?.isLocked ||
      subFolderState?.data?.isLocked ||
      subFolderState?.status === 403);
  const lockedMessage =
    subFolderState?.response?.data?.message ||
    "This folder is locked right now by admin please contact to admin";

  const handleCloseFileModal = () => {
    setCreateFileModal(!createFileModal);
  };

  const handleFolderActionFromChild = () => {
    setFolders([]);
    setFiles([]);
    //("calling disptach");
    disptach(GetFolderAndFilesByParentlistAction(id));
  };

  useEffect(() => {
    setFolders([]);
    setFiles([]);
    console.log("trying to run");
  }, []);

  // useEffect(() => {
  //   setFolders([]);
  //   setFiles([]);
  //   //("At first we running to get folder and file by parent id", id);
  //   if (id) disptach(GetFolderAndFilesByParentlistAction(id));
  // }, []);

  useEffect(() => {
    //("At first we running to get folder and file by parent id", id);
    if (id) disptach(GetFolderAndFilesByParentlistAction(id));
  }, [id]);

  useEffect(() => {
    setFolders([]);
    setFiles([]);
  }, [id]);

  const SubFolderSelector = useSelector(
    (state) => state.fileManager?.subFolder?.data?.data
  );

  useEffect(() => {
    // SubFolderSelector?.map((data) => {
    //   if (data.type === "folder") {
    //     let json = {
    //       id: data._id,
    //       name: data.name,
    //       files: data.files,
    //       subfolders: data.children,
    //     };
    //     const isDuplicateFolder = folders.some(
    //       (item) => item.id === data._id && item.name === data.name
    //     );
    //     if (!isDuplicateFolder) setFolders((prevFiles) => [...prevFiles, json]);
    //   } else {
    //     let json = {
    //       id: data._id,
    //       name: data.name,
    //       url: data.url,
    //     };
    //     const isDuplicateFiles = files.some(
    //       (item) => item.id === data._id && item.name === data.name
    //     );
    //     if (!isDuplicateFiles) setFiles((prevFiles) => [...prevFiles, json]);
    //   }
    // });

    SubFolderSelector?.filter((folder) => folder.parent === id)?.map((data) => {
      console.log(data.type, "data type");
      if (data.type === "folder") {
        let json = {
          id: data._id,
          name: data.name,
          files: data.files,
          subfolders: data.children,
          createdAt: data.createdAt,
        };
        const isDuplicateFolder = folders.some(
          (item) => item.id === data._id && item.name === data.name
        );
        if (!isDuplicateFolder) setFolders((prevFiles) => [...prevFiles, json]);
      }
    });

    SubFolderSelector?.filter((folder) => folder.folder === id)?.map((data) => {
      console.log("print for files");
      let json = {
        id: data._id,
        name: data.name,
        url: data.url,
        createdAt: data.createdAt,
      };
      const isDuplicateFiles = files.some(
        (item) => item.id === data._id && item.name === data.name
      );
      if (!isDuplicateFiles) setFiles((prevFiles) => [...prevFiles, json]);
    });

    //(folders, files);
  }, [SubFolderSelector, id]);

  // //(FolderSelector, "selected folder");

  // Handle file drop into a folder
  const handleDrop = async (file, folderId) => {
    //("handle drop", file, folderId);
    let data = {
      name: file.name,
      folder: folderId,
    };

    await UpdateFileService(data, file.id)
      .then((res) => {
        if (res.status === 200) {
          setFolders([]);
          setFiles([]);
          disptach(GetFolderAndFilesByParentlistAction(id));
          disptach(showSnackbar(res.data.message, "success"));
          // setFolders((prevFolders) =>
          //   prevFolders.map((folder) => {
          //     const res =
          //       folder.id === folderId
          //         ? { ...folder, files: [...folder.files, file] }
          //         : folder;
          //     //(res, "added folder");

          //     return res;
          //   })
          // );

          //(folders);
          // setFiles((prevFiles) => prevFiles.filter((f) => f.id !== file.id));
        }
      })
      .catch((e) => {
        disptach(showSnackbar(apiErrorMessage(e), "error"));
      });
  };

  // Handle moving a folder into another folder
  const moveFolder = async (sourceFolderId, destinationFolderId) => {
    //("move folder");
    const sourceFolder = folders.find((folder) => folder.id === sourceFolderId);
    let data = {
      name: sourceFolder.name,
      parent: destinationFolderId,
    };

    await UpdateFolderService(data, sourceFolderId)
      .then((res) => {
        if (res.status === 200) {
          setFolders([]);
          setFiles([]);
          if (id) disptach(GetFolderAndFilesByParentlistAction(id));

          disptach(showSnackbar(res.data.message, "success"));
        }
      })
      .catch((e) => {
        disptach(showSnackbar(apiErrorMessage(e), "error"));
      });

    // Remove the source folder from the main folder list
    // setFolders((prevFolders) =>
    //   prevFolders
    //     .filter((folder) => folder.id !== sourceFolderId) // Remove the folder from the main list
    //     .map((folder) =>
    //       folder.id === destinationFolderId
    //         ? { ...folder, subfolders: [...folder.subfolders, sourceFolder] }
    //         : folder
    //     )
    // );
  };

  // Handle folder click to display its files and subfolders
  const handleFolderClick = (folder) => {
    setSelectedFolder(folder);
    if (folder.isLocked && !isAdmin) {
      disptach(
        showSnackbar(
          "This folder is locked right now by admin please contact to admin",
          "error"
        )
      );
      return;
    }
  };

  const {
    search,
    setSearch,
    isSearching,
    filteredFolders,
    filteredFiles,
    resultCount,
  } = useFileManagerSearch(folders, files);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={8} xs={12}>
          <div
            className="d-flex align-items-center"
            style={{ cursor: "default" }}
          >
             <IconButton onClick={() => navigate(-1)}>
                          <ArrowBackIcon />
                        </IconButton>
            <Typography
              // onClick={() => disptach(GetFolderAndFilesByParentlistAction(id))}
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W600}
              fontSize={fontSize.h2.small}
            >
              My Folder
            </Typography>
            {/* <Typography
              className="px-2 pt-1"
              fontFamily={FontFamily.Poppins}
              fontSize={fontSize.h4.medium}
              fontWeight={fontWeight.W300}
              color={ThemeColor.GREY}
            >
              / Student List 2024 /
            </Typography> */}
          </div>
        </Grid>
        <Grid item lg={4} xs={12}>
          {!isFolderLocked && (
            <Box
              sx={{
                cursor: "default",
                gap: "8px",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: { xs: "stretch", lg: "flex-end" },
              }}
            >
            <FileManagerSearch
              value={search}
              onChange={setSearch}
              isSearching={isSearching}
            />

            <CustomButton
              variant="outlined"
              onClick={() => setCreateFolderModal(true)}
              color={ThemeColor.YELLOW}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                px: 1.5,
                py: 0.6,
                display: "flex",
                alignItems: "center",
                fontSize: fontSize.h4.medium,
                borderWidth: 1,
                border: `1px solid ${ThemeColor.YELLOW}`,
                '&:hover': { background: 'transparent' }
              }}
            >
              <AddCircleOutlined sx={{ mr: 1, color: ThemeColor.YELLOW }} />
              Create Folder
            </CustomButton>

            <CustomButton
              variant="outlined"
              onClick={() => setCreateFileModal ? setCreateFileModal(true) : null}
              color={ThemeColor.PURPLE}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                px: 1.5,
                py: 0.6,
                display: "flex",
                alignItems: "center",
                fontSize: fontSize.h4.medium,
                borderWidth: 1,
              }}
            >
              <AddCircleOutlined sx={{ mr: 1, color: ThemeColor.PURPLE }} />
              Create File
            </CustomButton>
          </Box>
          )}
        </Grid>
      </Grid>

      {isFolderLocked ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "45vh",
            textAlign: "center",
            p: { xs: 3, sm: 5 },
            background: "#ffffff",
            borderRadius: "16px",
            border: "1px solid #EAECF0",
            boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
            mt: 2,
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              bgcolor: "#FEF3F2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2.5,
            }}
          >
            <img src="/assest/lock.svg" alt="locked" width={36} height={36} />
          </Box>
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W600}
            fontSize={fontSize.h3.large}
            color={ThemeColor.BLACK}
            gutterBottom
          >
            Folder is Locked
          </Typography>
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W400}
            fontSize={fontSize.h4.medium}
            color="#475467"
            sx={{ maxWidth: 460 }}
          >
            {lockedMessage}
          </Typography>
        </Box>
      ) : (
        <div className="container-filemanager" style={{ cursor: "default" }}>
        <DndProvider
          backend={HTML5Backend}
          className="w-100"
          style={{ cursor: "default" }}
        >
          <List
            sx={{ width: "100%", maxWidth: "100%", cursor: "default" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            {filteredFolders?.length > 0 &&
              filteredFolders.map((folder) => (
                <Folder
                  handleFolderActionFromChild={handleFolderActionFromChild}
                  key={folder.id}
                  folder={folder}
                  onDrop={handleDrop}
                  moveFolder={moveFolder}
                  onClick={handleFolderClick}
                />
              ))}
          </List>
          <List
            sx={{ width: "100%", maxWidth: "100%" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          // subheader={
          //   <ListSubheader
          //     component="div"
          //     id="nested-list-subheader"
          //     sx={{ background: "none" }}
          //   >
          //     Folder
          //   </ListSubheader>
          // }
          >
            {filteredFiles?.length > 0 &&
              filteredFiles.map((file) => (
                <ListItem key={file.id} disablePadding sx={{ padding: 0 }}>
                  {/* <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                </ListItemButton> */}
                  <File
                    key={file.id}
                    file={file}
                    handleFolderActionFromChild={handleFolderActionFromChild}
                  />
                </ListItem>
              ))}
          </List>

          {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h2>Files</h2>
              {files.map((file) => (
                <File key={file.id} file={file} />
              ))}
            </div>
            <div>
              <h2>Folders</h2>
              {folders.map((folder) => (
                <Folder
                  key={folder.id}
                  folder={folder}
                  onDrop={handleDrop}
                  moveFolder={moveFolder}
                  onClick={handleFolderClick}
                />
              ))}
            </div>
            <div>
              <h2>Selected Folder</h2>
              {selectedFolder ? (
                <>
                  <h3>{selectedFolder.name}</h3>
                  {selectedFolder.files.length > 0 && <h4>Files:</h4>}
                  {selectedFolder.files.length > 0 ? (
                    selectedFolder.files.map((file) => (
                      <p key={file.id}>{file.name}</p>
                    ))
                  ) : (
                    <p>No files in this folder</p>
                  )}
                  {selectedFolder.subfolders.length > 0 && <h4>Subfolders:</h4>}
                  {selectedFolder.subfolders.length > 0 ? (
                    selectedFolder.subfolders.map((subfolder) => (
                      <p key={subfolder.id}>{subfolder.name}</p>
                    ))
                  ) : (
                    <p>No subfolders in this folder</p>
                  )}
                </>
              ) : (
                <p>Click on a folder to view its contents</p>
              )}
            </div>
          </div> */}

          {isSearching && resultCount === 0 && (
            <FileManagerNoResult search={search.trim()} />
          )}
        </DndProvider>
        </div>
      )}

        {/* modal for chat window */}
        <Modal
          open={createFolderModal}
          onClose={() => setCreateFolderModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              align="right"
              onClick={() => setCreateFolderModal(false)}
            >
              <Crossicon width={"20"} height={"20"} />
            </Typography>
            <Typography
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W600}
              fontSize={fontSize.h3.large}
              color={ThemeColor.BLACK}
              align="center"
            >
              Create Folder
            </Typography>
            <Formik
              initialValues={{
                name: "",
              }}
              // validationSchema={validationSchema}
              onSubmit={async (values, { resetForm }) => {
                //("FOLDER data:", values);
                values["parent"] = id;

                await CreateFolderService(values)
                  .then((res) => {
                    if (res.status === 200) {
                      // //(res);

                      if (id) disptach(GetFolderAndFilesByParentlistAction(id));
                      setFolders([]);
                      setFiles([]);

                      setCreateFolderModal(false);

                      disptach(showSnackbar(res.data.message, "success"));
                      // navigate("/CAE/CatalogueBrochureList");
                      resetForm();
                    }
                  })
                  .catch((e) => {
                    disptach(showSnackbar(apiErrorMessage(e), "error"));
                  });
              }}
              validationSchema={Yup.object().shape({
                name: Yup.string().required(
                  "Name of folder is must to create..."
                ),
              })}
            >
              {({
                values,
                errors,
                handleBlur,
                handleChange,
                touched,
                handleSubmit,
                setFieldValue,
              }) => (
                <Form className="d-flex justify-content-center">
                  <Box
                    className="addcatalog-container"
                    sx={{
                      width: { sm: "100%", xs: "100%", md: "100%", lg: "100%" },
                      position: "absolute",
                      bottom: "0%",
                    }}
                  >
                    <FormGroup style={{}}>
                      <div className="d-flex justify-content-between">
                        <div className="px-2 w-100">
                          <OutlinedInputField
                            value={values.name}
                            name={"name"}
                            onChange={handleChange}
                            placeholder="Folder Name...."
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.name}
                              </Typography>
                            }
                          />
                        </div>
                        <div className="px-3">
                          <CustomButton
                            variant="contained"
                            type="submit"
                            backgroundColor={ThemeColor.PURPLE}
                            color={ThemeColor.WHITE}
                          // loading={formLoading}
                          //   padding={"0px"}
                          // onClick={handleClick}
                          >
                            Create
                          </CustomButton>
                        </div>
                      </div>
                    </FormGroup>

                    <div className="d-flex justify-content-center align-items-center h-100 w-100 mt-5"></div>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Modal>

      <CreateFileModal
        handleClose={handleCloseFileModal}
        createFileModal={createFileModal}
        folderId={id}
      />

    </>
  );
};

function SubFolderFileManagementStd() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<FolderManagement />} />
    </div>
  );
}

export default SubFolderFileManagementStd;
